import { Modal, Backdrop, Fade, createStyles, makeStyles, TableRow, Theme, withStyles, Table, TableContainer, Paper, Typography, TableCell, TableHead, TableBody, Button, Box } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { alertsConfirmAction, itemReviewCloseAction, itemReviewListCloseAction, itemReviewOpenAction } from "../features/sliceReducer/interactionReducer";
import { addReviewsActions, createItemReview, deleteItemReview, deleteReviewsActions, updateItemReview, updateReviewsActions } from "../features/sliceReducer/myProjectReducer";
import { RootState } from "../features/store";
import { initializeIPItemReview, IPItemReview } from "../models/IPItemReview";
import ItemReviewModal from "./ItemReviewModal";
import Loading from "./Loading";

//material-UI-Style
const StyledTableRow = withStyles((theme: Theme) =>
  createStyles({
    root: {
      "&:nth-of-type(odd)": {
        backgroundColor: theme.palette.action.hover,
      },
    },
  })
)(TableRow);

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    modal: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    paper: {
      width: "1480px",
      minWidth: "1480px",
      height: "880px",
      overflowY: "auto",
      backgroundColor: theme.palette.background.paper,
      border: `2px solid ${theme.palette.primary.main}`,
      boxShadow: theme.shadows[5],
      padding: theme.spacing(3, 6, 3),
    },

    table: {
      // minWidth: 650,
      border: "1px solid #dbdce0",
    },
    buttonCell: {
      display: "flex",
      width: "100%",
    },
    modalTitle: {
      marginBottom: " 30px",
      textAlign: "center",
      fontWeight: "bold",
    },
    searchInput: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginBottom: " 20px",
      "& form": {
        marginRight: "36px",
      },
    },

    buttonStyle: {
      display: "flex",
      justifyContent: "center",

      "& button": {
        width: "200px",
        height: "40px",
        marginTop: "80px",
      },
    },

    buttonMargin: {
      flex: "0 0 auto",
      width: "80px",
      height: "36px",
      marginRight: "18px",
    },
  })
);

interface ItemReviewListModalProps {
  isMeeting: boolean;
  containerUID: number;
}

const ItemReviewListModal = (props: ItemReviewListModalProps) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { itemReviewListModalToggle, itemReviewModalToggle } = useSelector(
    (state: RootState) => state.interaction
  );
  const {
    myProject,
    loading,
  } = useSelector((state: RootState) => state.myProject);
  const { userToken } = useSelector((state: RootState) => state.auth);

  const [reviewItems, setReviewItems] = useState(props.isMeeting ? myProject.meetingReviews : myProject.evalReviews);
  const [reviewItemValue, setReviewItemValue] = useState({
    ...initializeIPItemReview,
    isMeeting: props.isMeeting,
    projectUID: myProject.uid,
    containerUID: props.containerUID,
  });
  useEffect(() => {
    setReviewItems(props.isMeeting ? myProject.meetingReviews : myProject.evalReviews)
  });

  // const deleteHandler = (item: IPItemReview) => {
  //   if (item.uid !== 0) {
  //     dispatch(deleteItemReview({
  //       userToken, id: item.uid, successHandler: () => {
  //         dispatch(deleteReviewsActions({ uid: item.uid, isMeeting: item.isMeeting }))
  //       }
  //     }));
  //   }
  //   dispatch(itemReviewCloseAction());
  // }

  const createHandler = (item: IPItemReview) => {
    dispatch(addReviewsActions(item));
    dispatch(itemReviewCloseAction());
  }

  const updateHandler = (item: IPItemReview) => {
    // alert(item.review);
    dispatch(updateReviewsActions(item));
    dispatch(itemReviewCloseAction());
  }

  const failHandler = () => {

  }

  return (
    <React.Fragment>
      <ItemReviewModal
        itemReview={reviewItemValue}
        updateHandler={(review: IPItemReview) => {
          // TODO 
          if (review.uid === 0) {
            review.projectUID = myProject.uid;
            review.isMeeting = props.isMeeting;
            review.containerUID = props.containerUID;
            dispatch(createItemReview({ userToken, item: review, successHandler: (model: IPItemReview) => createHandler(model), failHandler }));
          }
          else dispatch(updateItemReview({ userToken, item: review, successHandler: (model: IPItemReview) => updateHandler(model), failHandler }));
        }}
      />
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={itemReviewListModalToggle}
        onClose={() => {
          dispatch(itemReviewListCloseAction());
        }}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={itemReviewListModalToggle}>
          <TableContainer component={Paper} className={classes.paper}>
            {itemReviewListModalToggle || <Loading loading={loading} />}

            <Typography
              className={classes.modalTitle}
              variant="h5"
              component="h5"
            >
              {props.isMeeting ? "면담사진" : "총평자료"}
            </Typography>
            <Box px={2} display="flex" justifyContent="flex-end" >
              <Button variant="contained" color="primary"
                onClick={() => {
                  setReviewItemValue({ ...initializeIPItemReview });
                  dispatch(itemReviewOpenAction());
                }}
              >추가</Button>
            </Box>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell key={"id"} align="center">#</TableCell>
                  <TableCell key={"review"} align="center">내용</TableCell>
                  <TableCell key={"functions"} align="center"></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {reviewItems?.filter(x => x.containerUID == props.containerUID).map((item, index) => {
                  return (
                    <TableRow>
                      <TableCell key={item.uid + "-" + index}>{(index + 1)}</TableCell>
                      <TableCell key={item.uid + "-" + index}>{item.review}</TableCell>
                      <TableCell key={item.uid + "-" + index}>
                        <Box display="flex" justifyContent="flex-end" >
                          <Box p={1}>
                            <Button variant="contained" color="primary"
                              onClick={() => {
                                setReviewItemValue(item);
                                dispatch(itemReviewOpenAction());
                              }}
                            >편집</Button>
                          </Box>
                          <Box p={1}>
                            <Button variant="contained" color="secondary"
                              onClick={() => {
                                dispatch(
                                  alertsConfirmAction({
                                    alertContent: "해당 항목을 삭제하시겠습니까?",
                                    alertAction: deleteItemReview({
                                      userToken, id: item.uid, successHandler: () => {
                                        dispatch(deleteReviewsActions({ uid: item.uid, isMeeting: item.isMeeting }))
                                      }
                                    })
                                  })
                                );
                              }}
                            >삭제</Button>
                          </Box>
                        </Box>
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
        </Fade>
      </Modal >
    </React.Fragment>
  )
}
export default ItemReviewListModal;